<div class="pending-appointments-wrapper">
    <div class="title">{{ 'vehicleManagement.upcomingTestdriveAppointmentsWithUnavailableVehicles' | translate}} <span *ngIf="(allAppointmentsCount$ | async) > 0">({{allAppointmentsCount$ | async }})</span></div>
    <section *ngIf="!(isLoading$ | async); else loader">
  
  
      <div class="no-appointment" *ngIf="!(appointments?.length > 0) && searchValues.length === 0 && !isSearchLoading">
        <mat-icon class="mat-icon">info_outline</mat-icon>
        <span class="label">{{ 'pendingAppointments.noAppointmentsFound' | translate}}</span>
      </div>
      <div *ngIf="searchValues.length > 0" class="search-group d-flex">
        <div class="d-flex filter-group">
          <div *ngFor="let search of searchValues, let i = index" class="filter-list">
            <div class="filter-value d-flex" *ngIf="search.colValue">
              <div class="filter-text">
      
                <span>{{search.colValue | translate}}</span>
      
              </div>
      
              <div class="icon"(click)="onCloseFilterValue(search.column, i)">
                <mat-icon class="clear-icon">clear</mat-icon>
              </div>
      
            </div>
          </div>
        </div>
        <div class="arrow-button" (click)="scrollUp()">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </div>
  
        <div class="arrow-button" (click)="scrollDown()"> 
          <mat-icon>keyboard_arrow_right</mat-icon>
        </div>
        <div class="d-flex" style="width: 3%">
          <div (click)="clearFilters()" class='action enabled clear-btn-style'>
            <div class="btnText clear-btn-text">{{ 'servicePersonnel.clear' | translate }}</div>
          </div>
        </div>
      </div>
      <div [hidden]="!(appointments?.length > 0) && searchValues.length === 0 && !isSearchLoading">
        <div class="panel-left" tabindex="0" [ngClass]="searchValues.length > 0 ? 'withSearch' : ''">
          <div style="width: 80%">
  
            <div class="table-responsive appointment-tbl" [ngClass]="searchValues.length > 0 ? 'withSearch' : ''">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="table alternateColor">
                <caption style="display: none;"> </caption>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef aria-label="row actions" scope="col">
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span>
                      <button mat-icon-button [matMenuTriggerFor]="actionMenu" aria-label="More actions"
                        style="padding: 0px; height: 10px; width: 10px;">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #actionMenu="matMenu" class="custom-checklist-summary-menu1">
                        <button mat-menu-item (click)="editAppointment(element)" (keyup.enter)="editAppointment(element)" (keydown.enter)="editAppointment(element)">
                          <div class="action-btn action-icon action-btn-edit"></div>
                          {{ 'testDrive.editAppointment' | translate }}
                        </button>
                        <button mat-menu-item
                        (click)="cancelAppointment($event, element)" (keyup.enter)="cancelAppointment($event, element)" (keydown.enter)="cancelAppointment($event, element)">
                          <div class="action-btn action-icon action-btn-cancel"></div>
                          {{ 'deliveryChecklist.cancel' | translate }}
                        </button>
                      </mat-menu>
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef aria-label="row actions" scope="col">
                  </th>
                  <td mat-cell *matCellDef="let element">
  
                    <span>
                      <mat-checkbox (click)="$event.stopPropagation()">
                      </mat-checkbox>
                    </span>
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="{{column.id}}" *ngFor="let column of initColumns">
                  <th mat-header-cell *matHeaderCellDef scope="col" >
                    <div class="d-flex" style="cursor: pointer;" [title]="column.display | translate" *ngIf="column.id !== 'edit' &&  column.id !== 'cancel' "
                    (click)="sortChange(column.id)">
                      <div class="column-name">{{column.display | translate}} </div>
                    <div *ngIf="column.id !== 'edit' &&  column.id !== 'cancel' && sortingField === column.id">
                      <mat-icon class="sort-icon" *ngIf="sortOrder === 'asc' "  [title]="('pendingAppointments.ascending' | translate)">arrow_downward</mat-icon>
                      <mat-icon class="sort-icon" *ngIf="sortOrder === 'desc' "  [title]="('pendingAppointments.descending' | translate)">arrow_upward</mat-icon></div>
                  </div>
                  <div class="d-flex column-name" [title]="column.display | translate" *ngIf="column.id === 'edit' || column.id === 'cancel'">
                   {{column.display | translate}} 
                </div>
                  </th>
                  <td mat-cell *matCellDef="let element">
  
                    <span *ngIf="column.id === 'customerName'">
                      <span [title]="getCustomerDisplayName(element.customer)">{{getCustomerDisplayName(element.customer)}}</span>
                    </span>
  
                    <span *ngIf="column.id === 'contactInfo'">
                      <span title="{{element.customer.emailAddress ? element.customer.emailAddress : element.customer.phoneNumber}}">{{element.customer.emailAddress ? element.customer.emailAddress : element.customer.phoneNumber}}</span>
                    </span>
  
                    <span *ngIf="column.id === 'model' || column.id === 'vin' "
                      [title]="element.vehicle[column.col] ? element.vehicle[column.col] : 'NA'">
                      {{element.vehicle[column.col] ? element.vehicle[column.col] : 'NA'}}</span>
  
                    <span *ngIf="column.id === 'source'"
                      [title]="element.vehicle[column.col] ? (getSource(element.vehicle[column.col]) | translate) : 'NA'">
                      {{element.vehicle[column.col] ? (getSource(element.vehicle[column.col]) | translate) : 'NA'}}</span>
  
                      <span *ngIf="column.id === 'appointmentStartDate' "
                      [title]="element[column.col] ? getAppointmentCreatedDateTime(element[column.col], element.timeSlotId) : ''">
                      {{element[column.col] ? getAppointmentCreatedDateTime(element[column.col], element.timeSlotId) : ''}} </span>
  
                  </td>
                </ng-container>

                <ng-container matColumnDef="{{column.id}}" *ngFor="let column of initColumnsForFilter">
                  <div>
                    <th mat-header-cell *matHeaderCellDef scope="col" class="filter-header">
                
                      <form [formGroup]="searchForm">
                
                        <div *ngIf="column.id === 'selectFilter' ">
                          <mat-icon class="search-icon">search</mat-icon>
                        </div>
                
                        <div style="margin-top: 0.5rem"
                          *ngIf="column.id !== 'selectFilter' && column.id !== 'actionsFilter'">
                          <input matInput [formControlName]="column.id" #searchValue autocomplete="off"
                            [ngClass]=" searchValue.value ? 'opacity-1' : 'opacity-0'" placeholder="{{column.display | translate}}"
                            (keyup.enter)="addSearchField(column.id, searchValue.value)"
                            (keydown.tab)="addSearchField(column.id, searchValue.value)">
                        </div>
                
                      </form>
                    </th>
                  </div>
                </ng-container>
                
                <ng-container matColumnDef="noRecord">
                  <td mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplay.length" class="text-center">
                    <div style="margin-top: 5rem;">
                      <mat-icon class="mat-icon no-record-icon">info_outline</mat-icon>
                    </div>
                    <div class="no-record-label">{{'vehicleManagement.noMatchFound' | translate}}</div>
                    <div (click)="clearFilters()" class='action enabled no-record-clear-btn'>
                      <div class="btnText no-record-clear-btn-text">{{'vehicleManagement.clearFilters' | translate}}</div>
                    </div>
                  </td>
                </ng-container>
                
                <ng-container matColumnDef="searchLoader">
                  <td mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplay.length" class="text-center">
                    <div id="search-appointment-loading">
                      <app-loading size="0.8" color="var(--primary-sec-color)" loadingSymbol="dots"
                        [text]="'serviceSchedule.loading' | translate">
                      </app-loading>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"
                  [class.no-record-header]="dataSource.data.length === 0"></tr>

                  <tr mat-header-row *matHeaderRowDef="columnsToDisplayForFilter; sticky: true" class="filter-row"></tr>
  
                <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row">
                </tr>

                <tr mat-footer-row *matFooterRowDef="['searchLoader']" class="search-loader" [class.no-row]="!isSearchLoading"></tr>
                
                <tr mat-footer-row *matFooterRowDef="['noRecord']"
                  [ngClass]="(dataSource.data.length === 0) && (searchValues.length > 0 && !isSearchLoading) ? 'no-record-row' : 'no-row'">
                </tr>
              </table>
            </div>
  
          </div>
  
        </div>
      </div>
    </section>
  
    <ng-template #loader>
      <div id="loading-spinner">
        <app-loading size="0.5" color="var(--primary-sec-color)"></app-loading>
      </div>
    </ng-template>
  </div>